export enum AutoUploadEntityEnum {
    mah = 'mah',
    sponsor = 'sponsor',
    atccode = 'atccode',
    source = 'source',
    pharmaceuticalForm = 'pharmaceuticalForm',
    roa = 'roa',
    mfl = 'mfl',
    attachment = 'attachment',
    approvedSubstance = 'approvedSubstance',
    approvedSubstanceNames = 'approvedSubstanceNames',
    developmentSubstance = 'developmentSubstance',
    authorisedProduct = 'authorisedProduct',
    developmentProduct = 'developmentProduct',
    medicinalProductType = 'mpt',
    abstractCompositions  = 'abstractCompositions',
    abstractStrengths = 'abstractStrengths',
    abstractFormulations = 'abstractFormulations',
    abstractPharmaceuticalProductsStrength = 'abstractPharmaceuticalProductsStrength',
    abstractPharmaceuticalProductsFormulation = 'abstractPharmaceuticalProductsFormulation',
    xevprmMessage = 'xevprmMessage',
    approvedSubstanceHist = 'approvedSubstanceHist',
    developmentSubstanceHist = 'developmentSubstanceHist',
    authorisedProductHist = 'authorisedProductHist',
    developmentProductHist = 'developmentProductHist',
    pharmaceuticalFormHist = 'pharmaceuticalFormHist',
    mahHist = 'mahHist',
    sponsorHist = 'sponsorHist',
    atccodeHist = 'atccodeHist',
    sourceHist = 'sourceHist',
    roaHist = 'roaHist',
    mflHist = 'mflHist',
    attachmentHist = 'attachmentHist',
}